import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd8ce3fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "step-confirmEmail",
  class: "container step-confirm-phone"
}
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = { class: "container__subheader t-center t-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeField = _resolveComponent("CodeField")!
  const _component_RecaptchaButton = _resolveComponent("RecaptchaButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.confirmEmail`)), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.confirmEmailParagraph`)), 1),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createVNode(_component_CodeField, {
        modelValue: _ctx.formData.confirmEmailCode2,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.confirmEmailCode2 = $event)),
          _ctx.checkLength
        ],
        name: "confirmEmailCode2",
        length: 6,
        placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.confirmEmailPlaceholder`),
        "handles-error": true
      }, null, 8, ["modelValue", "placeholder", "onUpdate:modelValue"]),
      _createVNode(_component_RecaptchaButton, {
        action: _ctx.Action.CONFIRM_EMAIL,
        data: _ctx.formData,
        "data-testid": "btn-confirmEmail-nextStep",
        "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.next`),
        class: "button button--submit",
        disabled: !_ctx.isValid
      }, null, 8, ["action", "data", "button-value", "disabled"]),
      _createElementVNode("button", {
        type: "button",
        class: "fix-phone-number",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateBack && _ctx.navigateBack(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.wrongPhoneOne`)) + " - ", 1),
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.wrongPhoneTwo`)) + " »", 1)
      ])
    ], 32)
  ]))
}